var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-custom01",class:_vm.buttonColor,on:{"click":function($event){return _vm.$emit('btnClick')}}},[_c('span',{staticClass:"btn-custom01-front",class:_vm.color_sub},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }